import React from 'react';
import PropTypes from 'prop-types';
import { Unveil } from '@homeaway/react-unveil';
import { AspectRatioCardImage } from '@homeaway/react-aspect-ratio-card';
import { SHORT_CAROUSEL_ASPECT_RATIO, TALL_CAROUSEL_ASPECT_RATIO } from '../constants';

const LazyLoadAspectRatioCardImage = ({ imageUri, aspectRatio }) => {
  return (
    <Unveil className="LazyLoadImage" threshold={100} useWindowAsScrollParent>
      {imageUri &&
        <AspectRatioCardImage
          imageUri={imageUri}
          aspectRatio={aspectRatio}
        />
      }
    </Unveil>
  );
};

LazyLoadAspectRatioCardImage.propTypes = {
  imageUri: PropTypes.string.isRequired,
  aspectRatio: PropTypes.oneOf([TALL_CAROUSEL_ASPECT_RATIO, SHORT_CAROUSEL_ASPECT_RATIO])
};

export default LazyLoadAspectRatioCardImage;